import React from 'react';
import { Link } from 'react-router-dom';
export function MiniTroopersHero() {
  return <section className="relative bg-ink pt-16 pb-24 overflow-hidden" data-id="element-2534">
      <div className="absolute inset-0 opacity-30" data-id="element-2535">
        <img src="https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Mini-Troopers-Storm-Taekwondo.jpg" alt="Kids Martial Arts" className="block w-full h-full object-cover" data-id="element-2536" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2537" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2538">
        <div className="max-w-2xl" data-id="element-2539">
          <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-2540">
            Ages 3-5
          </div>
          <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-2541">
            Mini Troopers: Big Skills for Little Learners
          </h1>
          <p className="text-xl text-off-white mb-8 leading-relaxed" data-id="element-2542">
            A fun, structured martial arts program designed specifically for
            preschoolers. We help active kids build focus, coordination, and
            listening skills in a positive environment.
          </p>
          <Link to="/SignMeUp" className="btn-primary" data-id="element-2543">
            Claim Your Free Week
          </Link>
        </div>
      </div>
    </section>;
}